import { render, staticRenderFns } from "./mainplayer.vue?vue&type=template&id=bdc8cdb2&scoped=true&"
import script from "./mainplayer.vue?vue&type=script&lang=js&"
export * from "./mainplayer.vue?vue&type=script&lang=js&"
import style0 from "./mainplayer.vue?vue&type=style&index=0&id=bdc8cdb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc8cdb2",
  null
  
)

export default component.exports